declare global {
  let __maintenanceBypassEnabled;
}
export function IsMaintenanceBypassEnabled() { return __maintenanceBypassEnabled; }
